import ModalWrapper from "../../../../components/Modal/ModalWrapper";
import TableWidget from "../../../../components/tables/TableWidget";
import { RecallSaleListInterface } from "../../../../redux/interfaces/recall.interface";
import {
  getRecallSalesTableData,
  recallSalesTableHeader,
} from "./tableConfigs/recallEntryDetailsTableConfig";

function RecallClientSalesModal({
  pharmacyName,
  sales,
  handleClose,
}: {
  pharmacyName: string;
  sales: RecallSaleListInterface[];
  handleClose: () => void;
}) {
  return (
    <ModalWrapper
      show
      title={`Vanzare "${pharmacyName}"`}
      modalSize="xl"
      handleClose={handleClose}>
      <div className="mt-6">
        <TableWidget
          className="[&_thead_th]:text-left"
          tableHeaderData={recallSalesTableHeader}
          tableItemsData={getRecallSalesTableData(sales)}
          withTablePagination={false}
          withRouteParams={false}
          emptyTableLabel="Nu exista vanzari identificate pentru aceasta farmacie"
        />
      </div>
    </ModalWrapper>
  );
}

export default RecallClientSalesModal;
